"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeMessage = exports.formatTimeChatList = exports.sortFromLatestToOldest = exports.sortChatsByLatestMessage = void 0;
exports.formatBookingRequestDate = formatBookingRequestDate;
exports.getFileNameFromPath = getFileNameFromPath;
exports.hasUnregisteredData = hasUnregisteredData;
var sortChatsByLatestMessage = function (chats) {
    if (chats.length === 0)
        return chats;
    return __spreadArray([], chats, true).sort(function (a, b) {
        var aLastMessage = a.last_message === null
            ? a.requests[a.requests.length - 1]
            : a.last_message;
        var bLastMessage = b.last_message === null
            ? b.requests[a.requests.length - 1]
            : b.last_message;
        return (new Date(bLastMessage.created).getTime() -
            new Date(aLastMessage.created).getTime());
    });
};
exports.sortChatsByLatestMessage = sortChatsByLatestMessage;
var sortFromLatestToOldest = function (data) {
    return __spreadArray([], data, true).sort(function (a, b) { return new Date(b.created).getTime() - new Date(a.created).getTime(); });
};
exports.sortFromLatestToOldest = sortFromLatestToOldest;
var formatTimeChatList = function (date) {
    var refDate = new Date(date);
    var today = new Date();
    var yesterday = new Date(today);
    var twoDaysAgo = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
    if (today.toDateString() === refDate.toDateString()) {
        return (refDate.getHours().toString().padStart(2, "0") +
            ":" +
            refDate.getMinutes().toString().padStart(2, "0"));
    }
    else if (yesterday.toDateString() === refDate.toDateString()) {
        return window.Translator.trans("chat.yesterday", {}, "js");
    }
    else if (twoDaysAgo.toDateString() === refDate.toDateString()) {
        return window.Translator.trans("chat.two_days_ago", {}, "js");
    }
    return (refDate.getDate().toString().padStart(2, "0") +
        "." +
        (refDate.getMonth() + 1).toString().padStart(2, "0") +
        "." +
        refDate.getFullYear().toString().slice(-2));
};
exports.formatTimeChatList = formatTimeChatList;
var formatTimeMessage = function (dateString) {
    var date = new Date(dateString);
    var year = date.getFullYear().toString().slice(-2);
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    var hours = date.getHours().toString().padStart(2, "0");
    var minutes = date.getMinutes().toString().padStart(2, "0");
    return "".concat(day, ".").concat(month, ".").concat(year, ", ").concat(hours, ":").concat(minutes, " Uhr");
};
exports.formatTimeMessage = formatTimeMessage;
function formatBookingRequestDate(dateString) {
    var date = new Date(dateString);
    var day = String(date.getDate()).padStart(2, "0");
    var month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    var year = date.getFullYear();
    return "".concat(day, ".").concat(month, ".").concat(year);
}
function getFileNameFromPath(input) {
    var parts = input.split("/");
    return parts[parts.length - 1];
}
function hasUnregisteredData(_a) {
    var paymentMethods = _a.paymentMethods, contacts = _a.contacts, messageString = _a.messageString;
    var emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
    var ibanRegex = /([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30})((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?/g;
    var paymentMethodIdentifiers = paymentMethods.map(function (paymentMethod) { return paymentMethod.identifier; });
    var identifyIBANs = function (message) {
        var _a;
        return (_a = message.match(ibanRegex)) !== null && _a !== void 0 ? _a : [];
    };
    var identifyEmails = function (message) {
        var _a;
        return (_a = message.match(emailRegex)) !== null && _a !== void 0 ? _a : [];
    };
    var hasUnregisteredIban = (function (identifiedIbans) {
        for (var i = 0; i < identifiedIbans.length; i++) {
            if (paymentMethodIdentifiers.includes(identifiedIbans[i]))
                continue;
            return true;
        }
        return false;
    })(identifyIBANs(messageString));
    var hasUnregisteredEmail = (function (identifiedEmails) {
        for (var i = 0; i < identifiedEmails.length; i++) {
            if (contacts.includes(identifiedEmails[i]) ||
                paymentMethodIdentifiers.includes(identifiedEmails[i]))
                continue;
            return true;
        }
        return false;
    })(identifyEmails(messageString));
    var unregisteredDataCount = Number(hasUnregisteredIban) + Number(hasUnregisteredEmail);
    return {
        hasUnregisteredIban: hasUnregisteredIban,
        hasUnregisteredEmail: hasUnregisteredEmail,
        unregisteredDataCount: unregisteredDataCount,
    };
}
